<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './common.css'; /* 导入全局样式 */
</style>



// WEBPACK FOOTER //
// src/App.vue